export function SubTitle({ subTitle }) {
	if (typeof subTitle === 'function') {
		return subTitle();
	}
	return subTitle;
}
